// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { AccordionSectionPanel } from "@insite/mobius/AccordionSection";
import { AccordionSectionHeaderProps } from "@insite/mobius/AccordionSection/AccordionSectionHeader";
import AccordionSectionPresentationPropsDefault from "@insite/mobius/AccordionSection/presentationProps";
import CollapseClose from "@keller/XDL/Icons/CollapseClose";
import CollapseOpen from "@keller/XDL/Icons/CollapseOpen";
import { xBaseTheme } from "@keller/XDL/types";
import { color } from "@keller/XDL/Utilities";
import { css } from "styled-components";

export default {
    defaultProps: {
        mergeCss: true,
    },
    sectionDefaultProps: {
        ...AccordionSectionPresentationPropsDefault,
        mergeCss: true,
        titleTypographyProps: {
            forwardAs: "span",
            size: 14,
            weight: "bold",
            color: "text.main",
        },
        toggleIconProps: {
            color: "primary",
            src: CollapseOpen,
            size: 16,
            css: css`
                &:hover {
                    color: ${color("common.ui1")};
                }
            `,
        },
        collapseIconProps: {
            src: CollapseClose,
            size: 16,
        },
        headerProps: {
            css: css`
                background: ${color("common.background")};

                button {
                    padding: 12px;
                    border-style: solid;
                    border-width: 1px;
                    border-color: ${color("common.border")};
                    border-bottom-color: transparent;
                    background: ${color("common.background")};
                }

                button:focus,
                ${AccordionSectionPanel} + & button:focus {
                    border-width: 1px;
                    border-color: ${color("common.border")};
                    border-bottom-color: transparent;
                    outline-width: 0;
                    padding: 12px;
                }

                ${({ expanded }: AccordionSectionHeaderProps) =>
                    !expanded &&
                    css`
                        button,
                        button:focus,
                        ${AccordionSectionPanel} + & button:focus {
                            border-bottom-color: ${color("common.border")};
                        }
                    `}
            `,
        },
        panelProps: {
            css: css`
                background: ${color("common.background")};
                padding: 12px;
            `,
        },
    },
} as xBaseTheme["accordion"];
